import React, { useContext } from "react";
import "./Card.css";
import { LandingPageContext } from "../../contexts/LandingPageContext";
import i18n from '../../i18n';

const Card = () => {
    const { firstSection } = useContext(LandingPageContext);

    // Helper function to extract text from potentially nested objects
    const getText = (value) => {
        if (typeof value === 'string') return value;
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            const currentLang = i18n.language || 'de';
            return value[currentLang] || value.de || value.en || '';
        }
        return String(value || '');
    };

    const cards = (firstSection.cards || []).map(card => ({
      id: card.id,
      title: getText(card.title),
      description: getText(card.description)
    }));

    return (
        <div className="wrapper">
            {cards.map(card => (
                <div key={card.id} className="card">
                    {card.title && (
                        <p className="card-title" style={{ color: firstSection.cardTitleColor || '#A08B7A' }}>
                           {card.title}
                         </p>
                    )}
                    <div className="description" style={{ color: firstSection.cardDescriptionColor || '#fff' }}>
                         {card.id === 3 && <img src="/raum.png" alt="Raum" style={{ width: '100%', marginTop: '1rem' }} />}
                         {card.description}
                     </div>
                </div>
            ))}
        </div>
    );
};

export default Card;
